if(typeof require !== 'undefined'){
    var $ = (typeof window.$ === 'function') ? window.$ : require('jquery');
}

import axios from "axios";
import i18n from '/Modules/Translations/Admin/assets/js/I18n'

let t = {}
let keys = [
    'polonr: are you sure to change person',
    'polonr: are you sure to change person desc',
    'validation: this value should not be blank.',
    'validation: this value is not a valid email address.',
    'yes',
    'no'
];


class MemberForm {
    static init($context = null) {
        var selector = "[data-list='member']";
        let $containers = $context ? $context.find(selector) : $(selector);

        $containers.each(function (index, element) {
            if ($(element).data('member_form_instance')) return;

            i18n.load(keys, t, function (){
                $(element).data('member_form_instance', new MemberForm(element))
            }, '/api/')

        });
    }

    //checkDataTimeoutId = null
    //currentProgress = 0
    lastLoadedDataKey = null
    lastLoadedCode = null
    ignoreLastChange = false

    constructor(element) {
        //console.log('MemberForm init on ', element)
        this.version = '0.0.1'
        this.element = element;
        this.$element = $(element);
        this.owner = this.$element.find('[name="rootOwner"]').val();
        this.list = this.$element.find('[name="list"]').val();
        this.token = this.$element.find('[name="_token"]').val();

        this.$nameInput = this.$element.find('[name*="Name"]');
        this.$surnameInput = this.$element.find('[name*="Surname"]');
        this.$codeInput = this.$element.find('[name*="PersonalCode"]');
        this.$citizenshipInput = this.$element.find('[name*="Citizenship"]');

        this.$countryInput = this.$element.find('[name*="[country]"]');
        this.$municipalityInput = this.$element.find('[name*="[municipality]"]');
        this.$cityInput = this.$element.find('[name*="[city]"]');
        this.$streetInput = this.$element.find('[name*="[street]"]');
        this.$buildingInput = this.$element.find('[name*="[building]"]');
        this.$premiseInput = this.$element.find('[name*="[premises]"]');
        this.$postcodeInput = this.$element.find('[name*="[postalCode]"]');
        this.$addressFullInput = this.$element.find('[name*="[addressFull]"]');

        this.$emailInput = this.$element.find('[name*="[Email:member]"]');
        this.$membershipFrom = this.$element.find('[name*="[MembershipDate:from]"]');
        this.$membershipUntil = this.$element.find('[name*="[MembershipDate:until]"]');

        this.$ignoreLeaveBtn = this.$element.find('button[type="submit"][name="action"][value="ignore-leave"]');
        this.$submitBtn = this.$element.find('button[type="submit"][name="submit"]');

        this.$nameInput.on('change', this.onSourceValueChange.bind(this))
        this.$surnameInput.on('change', this.onSourceValueChange.bind(this))
        this.$codeInput.on('change', this.onSourceValueChange.bind(this))


        this.$codeInput.on('keyup', function (e){
            if(this.lastLoadedCode && this.lastLoadedCode !== this.$codeInput.val() && this.ignoreLastChange === false){
                let buttonClicked = false;

                global.openConfirmModal({
                    title: t['polonr: are you sure to change person'],
                    message: t['polonr: are you sure to change person desc'],
                    ok: {
                        title: t['yes'],
                        callback: function (){
                            buttonClicked = true;
                            this.resetForm();
                        }.bind(this)
                    },
                    cancel: {
                        title: t['no'],
                        callback: function (){
                            buttonClicked = true;
                            this.$codeInput.val(this.lastLoadedCode);
                        }.bind(this)
                    },
                    onCloseCallback: function (){
                        if (buttonClicked) {
                            this.ignoreLastChange = false;
                        }else{
                            this.$codeInput.val(this.lastLoadedCode);
                        }
                    }.bind(this)
                })
                this.ignoreLastChange = true
            }

        }.bind(this))

        this.onSourceValueChange(0)

        this.$element.on('ajax-form.done', function (event, response) {

            if(response.formPreFillData){
                this.processSourceDataPersonData(response.formPreFillData)
            }
            this.$element.data('ignore_messages', false);

            if(response.status === 'ok'){
                this.$submitBtn.removeClass('d-none');
                this.$ignoreLeaveBtn.addClass('d-none')
                this.$emailInput.closest('.form-group').find('label').find('i.ph-asterisk').remove();
            }else{
                this.$submitBtn.addClass('d-none');

                if(
                    response.errorsCodes
                    && Object.keys(response.errorsCodes).length === 1
                    && response.errorsCodes['attributes[PersonalCode:member]'] === 'person_submitted_leave'
                ){
                    this.$ignoreLeaveBtn.removeClass('d-none')

                    let $label = this.$emailInput.closest('.form-group').find('label')
                    $label.html($label.html().trim() + '&nbsp;<i class="ph ph-asterisk"></i>')
                }else{
                    this.$ignoreLeaveBtn.addClass('d-none')
                    this.$emailInput.closest('.form-group').find('label').find('i.ph-asterisk').remove();
                }

            }

            this.lastLoadedDataKey = this.getCurrentDataKey();
            this.lastLoadedCode = this.$codeInput.val();



        }.bind(this))

        this.$element.on('ajax-form.before-submit', function (event, response) {
            //this.currentProgress = 0
        }.bind(this))
        this.$element.on('ajax-form.always', function (event, response) {
            //this.currentProgress = 0
        }.bind(this));

        [this.$citizenshipInput, this.$countryInput, this.$municipalityInput, this.$cityInput, this.$streetInput, this.$buildingInput, this.$premiseInput, this.$postcodeInput, this.$addressFullInput].forEach( $input => {
            this.makeReadonly($input, true)
        })


        this.$ignoreLeaveBtn.on('click', function (e){

            let email = this.$emailInput.val();
            let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            var error = null;
            if (email === '') {
                error = 'validation: this value should not be blank.';
            } else if (!emailRegex.test(email)) {
                error = 'validation: this value is not a valid email address.';
            }
            if(error){
                this.$emailInput.addClass('is-invalid').closest('.form-group').addClass('has-error').find('.invalid-feedback').html(t[error])
                e.preventDefault();
            }else{
                this.$emailInput.removeClass('is-invalid').closest('.form-group').removeClass('has-error').find('.invalid-feedback').html('')
            }

        }.bind(this))



        if(this.$membershipFrom.length && this.$membershipUntil.length){
            //neleidziam narystes pabaigos datos pasirinktis ankstesnes, jei nerystes pradzio data
            let fromInstance = this.$membershipFrom[0]._flatpickr;
            let untilInstance = this.$membershipUntil[0]._flatpickr;

            this.$membershipFrom.on('change', function (){
                let nextDay = new Date();
                if(this.value){
                    let vDate = flatpickr.parseDate(this.value);
                    if(typeof vDate !== 'undefined'){
                        nextDay = new Date(vDate.getTime() + 1000*60*60*24)
                    }
                }

                untilInstance.config.minDate = flatpickr.formatDate(nextDay, "Y-m-d");

            })

        }

    }

    basePath() {
        if ($('base').length) {
            return '';
        } else {
            return '/'
        }
    }

    onSourceValueChange(timeout = 2000) {
        if(this.ignoreLastChange){
            this.ignoreLastChange = false
            return
        }
        clearTimeout(this.fillDataTimeoutId)
        if (!this.$codeInput.val() || !this.$nameInput.val() || !this.$surnameInput.val()) return;
        if(this.lastLoadedDataKey === this.getCurrentDataKey()) return;
        this.fillDataTimeoutId = setTimeout(function () {
            this.validateFormData();
        }.bind(this), timeout)
    }

    validateFormData() {

        let $prefillRequest = $('<input type="hidden" name="_prefillRequest" value="1">')
        this.$element.append($prefillRequest)
        this.$element.find('button[type="submit"][value="validate"]').click();
        this.$element.data('ignore_messages', true)
        $prefillRequest.remove();
    }
    // loadSourceData() {
    //
    //     [this.$codeInput, this.$nameInput, this.$surnameInput].forEach(($input) => this.removeValidationError($input))
    //
    //     this.currentProgress = 0
    //     this.increaseProgress()
    //
    //     axios.postForm(`${this.basePath()}lists/request_member_data`, {
    //         _token: this.token,
    //         list: this.list,
    //         owner: this.owner,
    //         name: this.$nameInput.val(),
    //         surname: this.$surnameInput.val(),
    //         code: this.$codeInput.val(),
    //     }).then(response => {
    //         this.lastLoadedDataKey = this.getCurrentDataKey();
    //         if (response.data.uuid) {
    //             if (response.data.status === 'done') {
    //                 this.processSourceData(response.data.response)
    //             } else {
    //                 this.checkStatus(response.data.uuid)
    //             }
    //
    //         } else {
    //         }
    //     }).catch(error => {
    //     }).finally(() => {
    //     })
    // }

    // checkStatus(uuid) {
    //     preloader.show()
    //     setTimeout(() => {
    //         this.requestStatusUpdate(uuid)
    //     }, 5000)
    // }

    // requestStatusUpdate(uuid) {
    //     this.increaseProgress();
    //     axios.get(`${this.basePath()}lists/check_request_status`, {
    //         params: {
    //             uuid: uuid,
    //         }
    //     }).then(response => {
    //         if (response.data.status === 'done') {
    //             this.processSourceData(response.data.response)
    //             preloader.hide()
    //         } else if (response.data.status) {
    //             this.checkStatus(uuid)
    //         }
    //     }).catch(error => {
    //         this.lastLoadedDataKey = null;
    //         preloader.hide()
    //     }).finally(() => {
    //
    //     })
    // }

    // increaseProgress(step = 10) {
    //     this.currentProgress += step
    //     preloader.progress(Math.min(this.currentProgress, 100))
    // }

    // processSourceData(data) {
    //     if(data.success){
    //         this.processSourceDataPersonData(data.data)
    //     }else{
    //         this.processSourceDataError(data.error)
    //     }
    // }

    // processSourceDataError(error) {
    //     [this.$codeInput, this.$nameInput, this.$surnameInput].forEach(($input) => this.addValidationError($input, error))
    // }
    processSourceDataPersonData(personData) {

        if(this.$municipalityInput.val().length === 0){
            this.$nameInput.val(personData.name)
            this.$surnameInput.val(personData.surname)

            if(personData.citizenship?.code){
                this.$citizenshipInput.val(personData.citizenship?.code).trigger('change');
                this.makeReadonly(this.$citizenshipInput, true)
            }else{
                this.makeReadonly(this.$citizenshipInput, false)
            }

            if(personData.address?.country === 'LT'){
                this.$countryInput.val(personData.address.country).trigger('change');
                this.$municipalityInput.val(personData.address?.municipality).trigger('change');

                if(personData.address?.city){
                    this.$cityInput.find('option').remove();
                    this.$cityInput.append(
                        new Option(personData.address.city_title, personData.address.city, false, false)
                    )
                    this.$cityInput.val(personData.address.city).trigger('change');
                }
                if(personData.address?.street){
                    this.$streetInput.find('option').remove();
                    this.$streetInput.append(
                        new Option(personData.address.street_title, personData.address.street, false, false)
                    )
                    this.$streetInput.val(personData.address.street).trigger('change');
                }

                if(personData.address?.building){
                    this.$buildingInput.find('option').remove();
                    this.$buildingInput.append(
                        new Option(personData.address.address_title, personData.address.building, false, false)
                    )
                    this.$buildingInput.val(personData.address.building).trigger('change');
                }

                if(personData.address?.premises){
                    this.$premiseInput.find('option').remove();
                    this.$premiseInput.append(
                        new Option(personData.address.premises_title, personData.address.premises, false, false)
                    )
                    this.$premiseInput.val(personData.address.premises).trigger('change');
                }


                if(personData.address?.postcode){
                    this.$postcodeInput.find('option').remove();
                    this.$postcodeInput.append(
                        new Option(personData.address.postcode, personData.address.postcode, false, false)
                    )
                    this.$postcodeInput.val(personData.address.postcode).trigger('change');
                }
            }else if (personData.address){
                this.$countryInput.val('').trigger('change');
                this.$addressFullInput.val(personData.address?.address)
            }
        }

        if(personData.address?.readonly){
            [this.$countryInput, this.$municipalityInput, this.$cityInput, this.$streetInput, this.$buildingInput, this.$premiseInput, this.$postcodeInput, this.$addressFullInput].forEach( $input => {
                this.makeReadonly($input, true)
            })
        }else{
            [this.$countryInput, this.$municipalityInput, this.$cityInput, this.$streetInput, this.$buildingInput, this.$premiseInput, this.$postcodeInput, this.$addressFullInput].forEach( $input => {
                this.makeReadonly($input, false)
            })
        }


    }

    addValidationError($input, error) {
        $input.addClass('is-invalid').closest('.form-group').addClass('has-error').find('.invalid-feedback').html(error)
    }
    removeValidationError($input) {
        $input.removeClass('is-invalid').closest('.form-group').removeClass('has-error').find('.invalid-feedback').html('')
    }

    getCurrentDataKey(){
        return `${this.$nameInput.val()}-${this.$surnameInput.val()}-${this.$codeInput.val()}`.toLowerCase()
    }

    makeReadonly($input, readonly = true){
        $input.attr('readonly', readonly ? 'readonly' : null)
        if($input.hasClass('select2-hidden-accessible')){
            if(readonly){
                $input.data('select2')?.$container.addClass('select2-container--readonly');
            }else{
                $input.data('select2')?.$container.removeClass('select2-container--readonly');
            }

        }
    }

    resetForm(){
        this.$nameInput.val('');
        this.$surnameInput.val('');
        this.$citizenshipInput.val('').change()
        this.$emailInput.val('');

        this.$membershipFrom.val('');
        this.$membershipUntil.val('');

        this.$addressFullInput.val('')
        this.$postcodeInput.val('').change()
        this.$premiseInput.val('').change()
        this.$buildingInput.val('').change()
        this.$streetInput.val('').change()
        this.$cityInput.val('').change()
        this.$municipalityInput.val('').change()

        this.lastLoadedCode = null;
        this.lastLoadedDataKey = null;

        this.$submitBtn.addClass('d-none');
        this.$ignoreLeaveBtn.addClass('d-none')
        this.$emailInput.closest('.form-group').find('label').find('i.ph-asterisk').remove();
        this.$emailInput.removeClass('is-invalid').closest('.form-group').removeClass('has-error').find('.invalid-feedback').html('')


        this.removeValidationError(this.$codeInput);
        this.removeValidationError(this.$nameInput);
        this.removeValidationError(this.$surnameInput);
    }
}


if (typeof module === "object" && typeof module.exports === "object"){

    MemberForm.init()
    //node modules support
    module.exports = MemberForm;
}else{
    $(function(){
        MemberForm.init()
    });
}